export default __webpack_public_path__ + "static/media/Add_Database.eb5ac646.png";